import { defineComponent as _defineComponent } from 'vue';
import { renderSlot as _renderSlot, mergeProps as _mergeProps, createElementVNode as _createElementVNode, normalizeStyle as _normalizeStyle, openBlock as _openBlock, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue";
const _withScopeId = (n) => (_pushScopeId("data-v-0fd02500"), n = n(), _popScopeId(), n);
const _hoisted_1 = ["x", "y", "width", "height"];
import { loading_success } from "@/lib/helpers";
import { Rectangle } from "@/lib/rects/rectangle";
import { PublicStore } from "@/lib/store/public";
export default /*#__PURE__*/ _defineComponent({
    __name: 'SVGRect',
    props: {
        variant: {},
        visible: { type: Boolean, default: true },
        rectangle: {}
    },
    setup(__props) {
        const store = PublicStore();
        function get_bg_aspect_ratio() {
            if (!loading_success(store.background))
                return 1;
            return store.background.aspect_ratio;
        }
        return (_ctx, _cache) => {
            return (_openBlock(), _createElementBlock("foreignObject", {
                x: Math.round(get_bg_aspect_ratio() * _ctx.rectangle.left),
                y: _ctx.rectangle.top,
                width: Math.round(get_bg_aspect_ratio() * _ctx.rectangle.width),
                height: _ctx.rectangle.height,
                style: _normalizeStyle(`transform: scaleX(${1 / get_bg_aspect_ratio()})`)
            }, [
                _createElementVNode("div", _mergeProps({
                    xmlns: "http://www.w3.org/1999/xhtml",
                    class: `px-2 is-flex is-align-items-center is-justify-content-center is-size-2 has-text-weight-bold ${_ctx.variant} ${_ctx.visible ? 'visible' : ''}`,
                    style: { "height": "inherit" }
                }, _ctx.$attrs), [
                    _renderSlot(_ctx.$slots, "default")
                ], 16)
            ], 12, _hoisted_1));
        };
    }
});
